import { render, staticRenderFns } from "./DkoDetailsCard.vue?vue&type=template&id=9548e8ae"
import script from "./DkoDetailsCard.vue?vue&type=script&lang=js"
export * from "./DkoDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports